<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Remove My Account</li>
  </ol>
</nav>
<div [hidden]="loading" *ngIf="myBusiness" class="account-settings-container layout-top-spacing">

  <div class="d-flex flex-row my-5">
    <div>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_165_4992)">
          <path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#3431C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_165_4992">
            <rect width="18" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="mx-2" style="color: #4A4A4A">{{'To remove your account, do not hesitate to contact customer service and provide them with the following data to terminate it.'|translate}}</div>
  </div>


  <div class="iban-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="card p-3 position-relative my-5" style="max-width: 600px;color: #FEFEFE;border-radius: 20px;background: linear-gradient(242deg, #3431C8 19.28%, #AA3DFF 174.72%);box-shadow: -7px 0px 69px 0px rgba(0, 0, 0, 0.03);">
        <div class="row m-3">
          <div class="col-3 text-nowrap" translate>{{'Account Number' | translate}}:</div>
          <div class="col-8 mx-1" translate>{{this.myBusiness.accountNumber}}</div>
        </div>
        <div class="row m-3">
          <div class="col-3 text-nowrap" translate>{{'Mobile' | translate}}</div>
          <div class="col-8 mx-1" translate>{{this.myBusiness.mobileNumber}}</div>
        </div>
        <div class="row m-3">
          <div class="col-3 text-nowrap" translate>{{'License Name' | translate}}</div>
          <div class="col-8 mx-1" translate>{{this.myBusiness.licenseName}}</div>
        </div>
        <div class="triangle-up">
        </div>
      </div>
    </div>
  </div>


  <button *ngIf="!submitting && (isMerchant || isManager)" class="btn btn-primary" translate (click)="close()">Close</button>

</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
